import isEmpty from 'lodash/isEmpty'
import isNumber from 'lodash/isNumber'
import isBoolean from 'lodash/isBoolean'
import moment from 'moment'
import { TOBE_INTERCEPTED } from '@/modules/order/constants'
import { OrderTypeEnum } from '@/modules/afterSale/components/AfterSaleOrderTypeRadio'
const D7 = 6 // 7天
const D14 = 13 // 30天

const clearEmpty = data => {
    const temp = {}
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (!isEmpty(data[key]) || isNumber(data[key]) || isBoolean(data[key])) {
            temp[key] = data[key]
        }
    }
    return temp
}
const getArrayByString = (key, string) => {
    const temp = string ? string.replace(/\n+/g, ',').replace(',,', ',').replace(/，/gi, ',').split(',') : undefined
    return { [key]: temp }
}
const getQueryTime = time => {
    if (!time) {
        return {}
    }
    if (time?.leftValue) {
        return {
            [`${time?.leftValue}Start`]: time?.rightValue?.startTime,
            [`${time?.leftValue}End`]: time?.rightValue?.endTime,
        }
    }
}
export const transferSearchToData = ({ query }) => {
    const {
        time,
        interceptionTime,
        asIds,
        lids,
        oids,
        shopBuyerIds,
        applicants,
        isStatus = 0,
        interceptStatusList,
        wmsCoIdList,
        ...rest
    } = query

    let data = {}

    if (isStatus) {
        data = {}
    } else {
        try {
            data = {
                ...getQueryTime(time),
                ...getQueryTime(interceptionTime),
                ...getArrayByString('asIds', asIds),
                ...getArrayByString('lids', lids),
                ...getArrayByString('oids', oids),
                ...getArrayByString('shopBuyerIds', shopBuyerIds),
                ...getArrayByString('applicants', applicants),
                ...getArrayByString('interceptStatusList', interceptStatusList),
                ...getArrayByString('wmsCoIdList', wmsCoIdList),
                ...rest,
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    return clearEmpty(data)
}
export const getInitialValues = (overdueQuery, pageQuery) => {
    const { orderTypeEnum } = pageQuery || {}

    return {
        time: {
            leftValue: 'asDate',
            rightValue: overdueQuery[TOBE_INTERCEPTED]?.checked
                ? {
                      startTime: moment()?.subtract(D7, 'days').format('YYYY-MM-DD 00:00:00'),
                      endTime: moment()?.format('YYYY-MM-DD 23:59:59'),
                  }
                : undefined,
        },
        interceptionTime: {
            leftValue: 'applicationTime',
            rightValue: overdueQuery[TOBE_INTERCEPTED]?.checked
                ? undefined
                : {
                      startTime: moment()?.subtract(D14, 'days').format('YYYY-MM-DD 00:00:00'),
                      endTime: moment()?.format('YYYY-MM-DD 23:59:59'),
                  },
        },
        orderTypeEnum: orderTypeEnum || OrderTypeEnum.ALL,
    }
}
